(function() {
    'use strict';
    const AppViewModel = require('./viewmodels/appViewModel');
    const $ = require('jquery');
    const ko = require('knockout');

    if (window.IsLoggedIn) {
        setInterval(function () {
            $.ajax({
                url: '/auth/isLoggedIn',
                success: function (result) {
                    if (!result.hasOwnProperty('isLoggedIn') || !result.isLoggedIn) {
                        $('#loginAlert').removeClass('hidden');
                    } else {
                        $('#loginAlert').addClass('hidden');
                    }
                },
                error: function () {
                    $('#loginAlert').removeClass('hidden');
                }
            });
        }, 5000);
    }

    let params = window.ViewModelParams || {};
    let viewModel = null;

    switch (window.ViewModel) {
        case 'IndexViewModel':
            let IndexViewModel = require('./viewmodels/indexViewModel');
            viewModel = new IndexViewModel(params);
            break;
        case 'RoleplayViewModel':
            let RoleplayViewModel = require('./viewmodels/roleplayViewModel');
            viewModel = new RoleplayViewModel(params);
            break;
        case 'EditRoleplayViewModel':
            let EditRoleplayViewModel = require('./viewmodels/editRoleplayViewModel');
            viewModel = new EditRoleplayViewModel(params);
            break;
        case 'ChapterViewModel':
            let ChapterViewModel = require('./viewmodels/chapterViewModel');
            viewModel = new ChapterViewModel(params);
            break;
        case 'EditChapterViewModel':
            let EditChapterViewModel = require('./viewmodels/editChapterViewModel');
            viewModel = new EditChapterViewModel(params);
            break;
        case 'EditPostViewModel':
            let EditPostViewModel = require('./viewmodels/editPostViewModel');
            viewModel = new EditPostViewModel(params);
            break;
        case 'CharactersViewModel':
            let CharactersViewModel = require('./viewmodels/charactersViewModel');
            viewModel = new CharactersViewModel(params);
            break;
        case 'EditCharacterViewModel':
            let EditCharacterViewModel = require('./viewmodels/editCharacterViewModel');
            viewModel = new EditCharacterViewModel(params);
            break;
        case 'MembersViewModel':
            let MembersViewModel = require('./viewmodels/membersViewModel');
            viewModel = new MembersViewModel(params);
            break;
        case 'EditProfileViewModel':
            let EditProfileViewModel = require('./viewmodels/editProfileViewModel');
            viewModel = new EditProfileViewModel(params);
            break;
        case 'ProfileViewModel':
            let ProfileViewModel = require('./viewmodels/profileViewModel');
            viewModel = new ProfileViewModel(params);
            break;
        case 'CharacterViewModel':
            let CharacterViewModel = require('./viewmodels/characterViewModel');
            viewModel = new CharacterViewModel(params);
            break;
    }

    ko.applyBindings(new AppViewModel(viewModel, window.IsLoggedIn));
    window.ko = ko;
    window.$ = $;
})();


// WEBPACK FOOTER //
// ./resources/scripts/index.js